(function () {
    "use strict";

    angular.module("app").component("habilFvmPersonActions", {
        templateUrl: "@/fvmPerson/fvm-person-actions.html",
        bindings: {
            person: "=",
            request: "=",
        },
        controller: FvmPersonActionsController
    });
    FvmPersonActionsController.$inject = ["$rootScope", "controllerDecorator", "enumService", "userFunctions"];
    function FvmPersonActionsController($rootScope, controllerDecorator, enumService, userFunctions) {
        const userReferenceNbr = userFunctions.currentUserReferenceNbr();

        const personActionCodes = enumService.PersonActionCodes;
        const fvmInitialActions = enumService.FvmInitialActions;

        const vm = Object.assign(this, {
            ClearInvitation,
            SetSendInvitation,
            ChooseActions,
            CanChooseActions,
            ShouldSendNoAcknowledgement,
            CanResendNoAcknowledgementInvitation
        });
        controllerDecorator.Decorate(vm, ["navigation"]);

        vm.SendInvitation = false;
        vm.noAcknowledgementInvitation = null;
        
        vm.$onInit = initialize;

        function initialize() {
            vm.Countries = $rootScope.codeCountries;
            vm.Languages = $rootScope.codeLanguages;
            vm.JobFunctions = $rootScope.codeJobFunctions;
        }

        function CanChooseActions() {
            if (!vm.person ||
                !vm.request ||
                vm.request.InitialAction == fvmInitialActions.Change)
                return false;

            return vm.person.Action && ((vm.person.Action.Code === personActionCodes.StartIVM && !vm.person.IsLinkedToIvm && !vm.person.IVMLink) || (vm.person.NoAcknowledgementForClearanceCodes && !vm.person.IsInvitedToSignNoAcknowledgementDocument));
        }

        function ShouldSendNoAcknowledgement() {
            if (!vm.person ||
                !vm.request ||
                !vm.request.CanSecurityOfficerSelectActions ||
                vm.request.InitialAction == fvmInitialActions.Change)
                return false;

            return vm.person.Action && vm.person.Action.Code === personActionCodes.NoAcknowledgement && !vm.person.IsInvitedToSignNoAcknowledgementDocument && !vm.person.HasSendNoAcknowledgeDocument;
        }

        function CanResendNoAcknowledgementInvitation() {
            if (!vm.person || !vm.request)
                return false;

            return vm.person.Action && vm.person.IsInvitedToSignNoAcknowledgementDocument && !vm.person.HasSendNoAcknowledgeDocument;
        }

        function SetSendInvitation(value) {
            vm.SendInvitation = value;

            // Always check if there is a signature for the current user (SO) otherwise we can overwrite the no-ack signature of another SO
            const securityOfficer = vm.request.Persons.find(p => p.ReferenceNbr === userReferenceNbr);
            vm.noAcknowledgementInvitation = {
                RequestId: vm.request.PublicId,
                InviteeId: vm.person.PublicId,
                EmailAddress: vm.person.Email,
                Signature: securityOfficer ? securityOfficer.NoAcknowledgementSignature : null,
            };
        }

        function ClearInvitation(person) {
            if (person) {
                const invitee = vm.request.Persons.find(p => p.PublicId === vm.noAcknowledgementInvitation.InviteeId);
                invitee.NoAcknowledgementForClearanceCodes = person.NoAcknowledgementForClearanceCodes;
                invitee.Email = person.Email;
                invitee.IsInvitedToSignNoAcknowledgementDocument = person.IsInvitedToSignNoAcknowledgementDocument;

                const securityOfficer = vm.request.Persons.find(p => p.ReferenceNbr === userReferenceNbr);
                invitee.InvitedById = securityOfficer.PublicId;
                securityOfficer.NoAcknowledgementSignature = vm.noAcknowledgementInvitation.Signature;
            }

            vm.noAcknowledgementInvitation = null;
            vm.SendInvitation = false;
        }

        function ChooseActions() {
            const route = vm.Navigator.GetRouteBuilder("Person/Request/NewFromFVM?")
                .AddParameter("requestId", vm.request.PublicId)
                .AddParameter("fvmPersonId", vm.person.PublicId)
                .GetRoute();
            vm.Navigator.OpenRoute(route);
        }
    }
})();